import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    marginBottom: theme.spacing(12),
  },
  contractsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: theme.spacing(4, 3),
    width: '100%',
    ['@media (max-width:1500px)']: {
      gridTemplateColumns: '1fr',
    },
  },
  contract: {
    backgroundColor: theme.palette.bg.main,
  },
  verticalDivider: {
    width: theme.spacing(0.125),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: theme.spacing(0.5),
    background: theme.palette.dividersV2.main,
    height: theme.spacing(3),
  },
  topContainer: {
    backgroundColor: theme.palette.text.white,
    padding: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
    display: 'flex',
    justifyContent: 'space-between',
  },
  btnContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  uploadBtn: {
    marginLeft: theme.spacing(2),
  },
  buttonInnerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  actionIcon: {
    color: theme.palette.labraText.primary,
  },
  bottomContainer: {
    marginTop: theme.spacing(3),
  },
  rightSideContainer: {
    display: 'flex',
    gap: theme.spacing(2.25),
    alignItems: 'center',
  },
  nameContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  name: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraText.primary,
    fontFamily: theme.typography.fontFamily,
  },
  emptyHeadingContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  emptyHeading: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
  },
  externalIcon: {
    height: theme.spacing(1.75),
    width: theme.spacing(1.75),
    color: theme.palette.select.light,
    textDecoration: 'none',
    cursor: 'pointer',
  },
  successCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: theme.spacing(2),
    width: theme.spacing(2),
    padding: theme.spacing(0.25),
    borderRadius: '50%',
    backgroundColor: theme.palette.textBackground.dark,
  },
  failedCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: theme.spacing(2),
    width: theme.spacing(2),
    padding: theme.spacing(0.25),
    borderRadius: '50%',
    backgroundColor: theme.palette.labraV2Errors.main,
  },
  icon: {
    height: theme.spacing(1.5),
    width: theme.spacing(1.5),
    color: theme.palette.text.white,
    textDecoration: 'none',
  },
  downloadIcon: {
    opacity: 0.38,
  },
  buyerCardBottom: {
    display: 'flex',
    flexDirection: 'column',
  },
  tableWrapper: {
    width: '100%',
  },
  tableCell: {
    background: theme.palette.bg.main,
  },
  dimensionTableCell: {
    width: '35%',
  },
  priceTableCell: {
    width: '25%',
    textAlign: 'right',
  },
  quantityTableCell: {
    width: '20%',
    textAlign: 'right',
  },
  totalTableCell: {
    textAlign: 'right',
    background: theme.palette.bg.main,
  },
  customTableCell: {
    display: 'flex',
    justifyContent: 'flex-end',
    background: theme.palette.bg.main,
  },
  tableHeading: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.palette.labraText.description,
    lineHeight: '16px',
    fontStyle: 'normal',
    letterSpacing: '0px',
    width: '100%',
    padding: theme.spacing(0, 1.5, 1.5, 0),
  },
  customTableHeading: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.palette.labraText.description,
    lineHeight: '16px',
    fontStyle: 'normal',
    letterSpacing: '0px',
    width: '100%',
    padding: theme.spacing(0, 1.5, 1.5, 1.5),
  },
  modalTableHeading: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.palette.labraText.description,
    lineHeight: '16px',
    fontStyle: 'normal',
    letterSpacing: '0px',
    width: '100%',
  },
  tableValues: {
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.textField.dark,
    lineHeight: '20px',
    fontStyle: 'normal',
    letterSpacing: '0.25px',
  },
  priceContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    alignItems: 'center',
  },
  totalContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(1.25, 1.5),
    backgroundColor: theme.palette.bgV2.light,
    borderRadius: theme.spacing(0.5),
  },
  totalAmount: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.palette.labraText.tertiary,
    fontFamily: theme.typography.fontFamily,
  },
  amountContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  dollar: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    flexShrink: 0,
  },
  totalWrapper: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
  },
  amount: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: theme.palette.textField.dark,
    fontFamily: theme.typography.fontFamily,
  },
  total: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: theme.palette.textField.dark,
    fontFamily: theme.typography.fontFamily,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  footerActions: {
    display: 'flex',
    width: theme.spacing(58.75),
    alignItems: 'center',
  },
  totalText: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.375),
  },
  totalValue: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
  },
  buyerDetailContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  buyerIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: theme.spacing(0.375),
  },
  buyerDetail: {
    width: '85%',
  },
  buyerTotal: {
    justifyContent: 'flex-end',
  },
  customIcon: {
    backgroundColor: theme.palette.backgroundV2.blue,
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: theme.spacing(0.375),
  },
  noAmount: {
    marginRight: theme.spacing(0.25),
  },
  dimensionGap: {
    marginLeft: theme.spacing(0.75),
  },
  qtyGap: {
    marginLeft: theme.spacing(1),
  },
  totalGap: {
    marginRight: theme.spacing(0.75),
  },
  extraGap: {
    marginRight: theme.spacing(2.75),
  },
  planTitle: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    flexDirection: 'row',
    paddingLeft: theme.spacing(1.5),
    paddingBottom: theme.spacing(3.5),
  },
  planTitleText: {
    color: theme.palette.labraText.tertiary,
  },
}))
